import NetsuiteData from '../types/NetsuiteData'

export const state: NetsuiteData = {
  customer: null,
  orders: null,
  orderSummaries: null,
  currentOrder: null,
  orderItems: null,
  tracking: null,
  loading: false,
  submitting: false,
  error: null
}
